function arkProductIsThemeEditor() {
  let isFramed = false;

  try {
    isFramed = window.self !== window.top;
  } catch (error) {
    isFramed = true;
  }

  const referrer = document.referrer || "";
  let ancestorOrigins = "";

  try {
    ancestorOrigins = Array.from(window.location.ancestorOrigins || []).join(" ");
  } catch (error) {
    ancestorOrigins = "";
  }

  const search = window.location.search || "";
  const originHints = `${referrer} ${ancestorOrigins}`;
  const isAdminFrame = isFramed && /(admin\.shopify\.com|\/admin|myshopify\.com)/i.test(originHints);
  const hasEditorPreviewParams = /(?:[?&](?:_ab|_fd|_sc|pb|preview_theme_id|section_id)=)/.test(search);

  return Boolean(window.Shopify && Shopify.designMode) || isAdminFrame || (isFramed && hasEditorPreviewParams);
}

if (!window.customElements.get("swatch-dropdown")) {
  class SwatchDropdown extends HTMLElement {
    constructor() {
      super();

      this.spanFor = this.dataset.spanFor;
      this.dropdown = this.parentElement.querySelector(".select-custom__inner");

      if (this.spanFor) {
        this.addEventListener("click", this.activeFilterSort.bind(this), false);
      }

      if (this.dropdown) {
        this.setDropdownHeight();
      }
    }

    setDropdownHeight() {
      const resizeObserver = new ResizeObserver((entries) => {
        for (let entry of entries) {
          if (entry.target === this.dropdown) {
            this.parentElement.style.setProperty("--dropdown-height", `${entry.target.getBoundingClientRect().height}px`);
          }
        }
      });

      resizeObserver.observe(this.dropdown);
    }

    activeFilterSort() {
      const spanBlock = this.querySelector(`#${this.spanFor}`);

      if (!spanBlock) {
        return;
      }

      if (spanBlock.classList.contains("active")) {
        spanBlock.classList.remove("active");
      } else {
        spanBlock.classList.add("active");
      }
    }
  }

  customElements.define("swatch-dropdown", SwatchDropdown);
}


	if (!window.customElements.get("product-tiers")) {
		  class ProductTiers extends HTMLElement {
		    constructor() {
		      super();

		      try {
		        this.initializeProductTiers();
		      } catch (error) {
		        console.error("[ARK] Product tiers failed to initialize", error);
	        this.classList.remove("product-tiers--flexible-initializing");
	      }
	    }

	    initializeProductTiers() {
	      this.isThemeEditor = arkProductIsThemeEditor();
	      this.formId = this.dataset.form;
	      this.autoCaptionEnabled = this.dataset.autoCaption === "true";
	      this.bundleSelection = {};
      this.optionSelection = {};
      this.layoutMode = this.dataset.layoutMode || "cards";
      this.isFlexiblePlan = this.layoutMode === "flexible-plan";
      this.flexibleEnabled = this.dataset.flexibleDefaultOn !== "false";

      this.form = document.forms[this.formId];
      this.productTarget = this.closest(".product-container") || document;
      this.variantPicker = this.productTarget.querySelector("variant-radios-detail");
      this.tiers = this.querySelectorAll(".product-tier");
      this.radios = this.querySelectorAll(".product-tier input[type='radio']");
      this.variantData = this.getVariantData();
      this.currentVariant = this.getVariantFromForm() || this.variantData[0] || null;

      if (this.isFlexiblePlan) {
        this.initFlexiblePlanMode();
      }

      this.syncFromSelections();
      this.classList.remove("product-tiers--flexible-initializing");

      this.radios.forEach((radio) => {
        radio.addEventListener("change", () => {
          this.syncFromSelections();
        });
      });

      this.form?.addEventListener("variant:change", (evt) => {
        const variant = evt.detail.variant;

        if (variant) {
          this.currentVariant = variant;
        }

        window.setTimeout(() => {
          this.syncFromSelections();
        }, 0);
      });

      this.variantPicker?.addEventListener("change", () => {
        window.setTimeout(() => {
          this.syncFromSelections();
        }, 0);
      });

      this.productTarget.addEventListener("ark:bundle-selection:change", (evt) => {
        this.bundleSelection = {
          drops: evt.detail?.drops,
          bars: evt.detail?.bars
        };

        this.syncFromSelections();
      });

	      this.productTarget.addEventListener("ark:variant-option:change", (evt) => {
	        const optionIndex = Number(evt.detail?.optionIndex);
	        const value = evt.detail?.value;

        if (!Number.isInteger(optionIndex) || optionIndex < 0 || !value) {
          return;
        }

	        this.optionSelection[optionIndex] = value;
	        this.syncFromSelections();
	      });
	    }

    getVariantData() {
      const data = this.querySelector("[data-product-tiers-variants]");

      if (!data) {
        return [];
      }

      return theme.helpers.safelyParseJson(data.textContent) || [];
    }

    getVariantFromForm() {
      const variantId = this.form?.querySelector("input[name='id']")?.value;

      if (!variantId) {
        return null;
      }

      return this.variantData.find((variant) => {
        return `${variant.id}` === `${variantId}`;
      }) || null;
    }

    getSelectedTierSettings() {
      const checkedTier = this.querySelector(".product-tier input[type='radio']:checked")?.closest(".product-tier");

      return theme.helpers.safelyParseJson(checkedTier?.dataset.tierSettings) || {};
    }

    getPackageOptionIndex(settings, selectedOptions = this.currentVariant?.options || []) {
      const packageOptionIndex = Number(settings?.packageOptionIndex);

      if (Number.isInteger(packageOptionIndex) && packageOptionIndex >= 0) {
        return packageOptionIndex;
      }

      return selectedOptions.length > 1 ? selectedOptions.length - 1 : null;
    }

    getSelectedOptions() {
      const fallbackVariant = this.currentVariant || this.getVariantFromForm() || this.variantData[0] || {};
      const selectedOptions = [...(fallbackVariant.options || [])];
      const fieldsets = this.variantPicker?.querySelectorAll("fieldset") || [];

      fieldsets.forEach((fieldset, index) => {
        const activeLabel = fieldset.querySelector(".product__color-swatch-option.active[data-value]");
        const checkedInput = fieldset.querySelector("input[type='radio']:checked");
        const select = fieldset.querySelector("select");
        const value = activeLabel?.dataset.value || checkedInput?.value || select?.value;

        if (value) {
          selectedOptions[index] = value;
        }
      });

      Object.entries(this.optionSelection).forEach(([index, value]) => {
        selectedOptions[Number(index)] = value;
      });

      if (this.bundleSelection.drops) {
        selectedOptions[0] = this.bundleSelection.drops;
      }

      if (this.bundleSelection.bars) {
        selectedOptions[1] = this.bundleSelection.bars;
      }

      const selectedTierSettings = this.getSelectedTierSettings();
      const selectedPackageValue = selectedTierSettings.packageValue;
      const packageOptionIndex = this.getPackageOptionIndex(selectedTierSettings, selectedOptions);

      if (selectedPackageValue && packageOptionIndex !== null) {
        selectedOptions[packageOptionIndex] = selectedPackageValue;
      } else if (selectedTierSettings.optionName) {
        selectedOptions[0] = selectedTierSettings.optionName;
      }

      return selectedOptions;
    }

    findVariantByOptions(options) {
      if (!options.length) {
        return null;
      }

      return this.variantData.find((variant) => {
        return options.every((option, index) => variant.options[index] === option);
      }) || null;
    }

    getVariantForTier(tier, selectedOptions = this.getSelectedOptions()) {
      const settings = theme.helpers.safelyParseJson(tier?.dataset.tierSettings) || {};
      const options = [...selectedOptions];

      if (!options.length) {
        return null;
      }

      const packageOptionIndex = this.getPackageOptionIndex(settings, options);

      if (settings.packageValue && packageOptionIndex !== null) {
        options[packageOptionIndex] = settings.packageValue;
      } else if (settings.optionName) {
        options[0] = settings.optionName;
      }

      return this.findVariantByOptions(options);
    }

    syncFromSelections() {
      const selectedOptions = this.getSelectedOptions();
      const selectedVariant = this.findVariantByOptions(selectedOptions);

      if (selectedVariant) {
        this.currentVariant = selectedVariant;
      }

      this.syncVariantPickerPackageOption();
      this.updateTierVariantIds(selectedOptions);
      this.updateTierVisibilityAndSelection(selectedOptions);
      this.updateAutomaticCaptions(selectedOptions);
      this.updateFormVariantInput();
      this.syncFlexibleFrequency();
      this.updateFlexiblePlanData(selectedOptions);
      this.updateFlexibleDiscountLabels();
      this.updateFlexiblePrices();
      this.updateFlexiblePlanTitle();
      this.updateFlexibleActiveDeal();
    }

    syncVariantPickerPackageOption() {
      const selectedTierSettings = this.getSelectedTierSettings();
      const packageOptionIndex = this.getPackageOptionIndex(selectedTierSettings, this.currentVariant?.options || []);
      const packageValue = selectedTierSettings.packageValue || this.currentVariant?.options?.[packageOptionIndex];
      const fieldsets = this.variantPicker?.querySelectorAll("fieldset") || [];
      const packageFieldset = fieldsets[packageOptionIndex];

      if (!packageValue || !packageFieldset) {
        return;
      }

      packageFieldset.querySelectorAll(".product__color-swatch-option.active").forEach((label) => {
        label.classList.remove("active");
      });

      const packageInput = packageFieldset.querySelector(`input[type='radio'][value="${CSS.escape(packageValue)}"]`);

      if (!packageInput) {
        return;
      }

      packageInput.checked = true;

      const packageLabel = packageFieldset.querySelector(`label[for="${CSS.escape(packageInput.id)}"]`);

      if (packageLabel) {
        packageLabel.classList.add("active");
        packageLabel.dataset.value = packageValue;
        packageLabel.dataset.position = `${packageOptionIndex + 1}`;
      }
    }

    updateTierVariantIds(selectedOptions = this.getSelectedOptions()) {
      this.tiers.forEach((tier) => {
        const variant = this.getVariantForTier(tier, selectedOptions);
        const radio = tier.querySelector("input[type='radio']");

        if (variant && radio) {
          radio.dataset.variantId = variant.id;
        }
      });
    }

    updateTierVisibilityAndSelection(selectedOptions = this.getSelectedOptions()) {
      let selectedRadio = null;
      const selectedOptionName = selectedOptions[0] || this.currentVariant?.option1;

      this.tiers.forEach((tier) => {
        const settings = theme.helpers.safelyParseJson(tier.dataset.tierSettings) || {};
        const radio = tier.querySelector("input[type='radio']");
        const parent = tier.closest(".label-wrapper");
        const wrapper = parent || tier;
        let shouldShow = true;
        let shouldSelect = false;

        if (settings.optionName && settings.packageValue && !settings.mergedVariantTiers) {
          shouldShow = settings.optionName === selectedOptionName;
        }

        if (settings.packageValue) {
          const packageOptionIndex = this.getPackageOptionIndex(settings, selectedOptions);
          const selectedPackageValue = selectedOptions[packageOptionIndex] || this.currentVariant?.options?.[packageOptionIndex];

          shouldSelect = shouldShow && settings.packageValue === selectedPackageValue;
        } else if (settings.optionName) {
          shouldSelect = shouldShow && settings.optionName === selectedOptions[0];
        }

        wrapper.classList.toggle("!hidden", !shouldShow);

        if (radio) {
          radio.checked = shouldSelect;
          radio.toggleAttribute("checked", shouldSelect);

          if (shouldSelect) {
            selectedRadio = radio;
          }
        }
      });
    }

    updateFormVariantInput() {
      const variantIdInput = this.form?.querySelector("input[name='id']");
      const variant = this.currentVariant;
      const variantId = variant?.id;

      if (!variantIdInput || !variantId || `${variantIdInput.value}` === `${variantId}`) {
        return;
      }

      variantIdInput.value = variantId;
      variantIdInput.dispatchEvent(new Event("change", { bubbles: true }));
      this.form?.dispatchEvent(new CustomEvent("variant:change", {
        detail: {
          variant: variant
        }
      }));
    }

    updateAutomaticCaptions(selectedOptions = this.currentVariant?.options || []) {
      if (!this.autoCaptionEnabled) {
        return;
      }

      const drops = this.formatAutomaticCaptionValue(selectedOptions[0], 0);
      const bars = this.formatAutomaticCaptionValue(selectedOptions[1], 1);

      this.querySelectorAll("[data-auto-caption]").forEach((caption) => {
        const tier = caption.closest(".product-tier");
        const settings = theme.helpers.safelyParseJson(tier?.dataset.tierSettings) || {};
        const quantity = settings.autoCaptionQuantity || 1;
        const lines = [];

        if (drops) {
          lines.push({
            type: "drops",
            text: `${quantity}X ${drops} of 30ml`
          });
        }

        if (bars) {
          lines.push({
            type: "bars",
            text: `${quantity * 14} ${bars}`
          });
        }

        caption.innerHTML = "";

        lines.forEach((line) => {
          const item = document.createElement("div");

          item.dataset.autoCaptionLine = line.type;
          item.textContent = line.text;
          caption.appendChild(item);
        });
      });
    }

    initFlexiblePlanMode() {
      this.flexibleToggle = this.querySelector("[data-flexible-plan-toggle]");
      this.flexibleInfoToggle = this.querySelector("[data-flexible-plan-info-toggle]");
      this.flexibleInfo = this.querySelector("[data-flexible-plan-info]");
      this.flexibleInfoClose = this.querySelector("[data-flexible-plan-info-close]");
      this.flexiblePlanTitle = this.querySelector("[data-flexible-plan-title]");
      this.flexibleFrequency = this.querySelector("[data-flexible-frequency]");
      this.flexibleFrequencyToggle = this.querySelector("[data-flexible-frequency-toggle]");
      this.flexibleFrequencyLabel = this.querySelector("[data-flexible-frequency-label]");
      this.flexibleFrequencyMenu = this.querySelector("[data-flexible-frequency-menu]");
      this.flexibleFrequencyOptions = this.querySelector("[data-flexible-frequency-options]");
      this.handleFlexibleOutsideClick = this.handleFlexibleOutsideClick.bind(this);

      this.flexibleToggle?.addEventListener("click", () => {
        const nextState = this.flexibleToggle.getAttribute("aria-checked") !== "true";

        this.setFlexiblePlanState(nextState, true);
      });

      this.flexibleInfoToggle?.addEventListener("click", (event) => {
        event.stopPropagation();
        this.toggleFlexibleInfo();
      });

      this.flexibleInfo?.addEventListener("click", (event) => {
        event.stopPropagation();
      });

      this.flexibleInfoClose?.addEventListener("click", (event) => {
        event.stopPropagation();
        this.closeFlexibleInfo();
      });

      this.flexibleFrequencyToggle?.addEventListener("click", (event) => {
        event.stopPropagation();
        this.toggleFlexibleFrequencyMenu();
      });

      this.flexibleFrequencyMenu?.addEventListener("click", (event) => {
        event.stopPropagation();
      });

      document.addEventListener("click", this.handleFlexibleOutsideClick);
      this.setFlexiblePlanState(this.flexibleEnabled, false);

      const syncFlexibleUi = () => {
        if (!this.isThemeEditor) {
          this.selectKachingPanel(this.flexibleEnabled);
        }

        this.syncFlexibleFrequency(!this.isThemeEditor);
        this.updateFlexiblePlanData();
        this.updateFlexibleDiscountLabels();
        this.updateFlexiblePrices();
        this.updateFlexiblePlanTitle();
        this.updateFlexibleActiveDeal();
      };

      if (this.isThemeEditor) {
        window.requestAnimationFrame(syncFlexibleUi);
      } else {
        [0, 250, 800, 1600, 3000, 5000].forEach((delay) => {
          window.setTimeout(syncFlexibleUi, delay);
        });
      }

      const kaching = this.getKachingRoot();

      if (kaching && !this.isThemeEditor) {
        this.flexibleKachingObserver = new MutationObserver(() => {
          this.syncFlexiblePlanFromKaching();
        });
        this.flexibleKachingObserver.observe(kaching, {
          attributes: true,
          childList: true,
          subtree: true,
          attributeFilter: ["class", "checked", "aria-checked"]
        });
      }
    }

	    disconnectedCallback() {
	      if (typeof this.handleFlexibleOutsideClick === "function") {
	        document.removeEventListener("click", this.handleFlexibleOutsideClick);
	      }

	      this.flexibleKachingObserver?.disconnect?.();
	    }

    setFlexiblePlanState(enabled, syncKaching = true) {
      if (!this.isFlexiblePlan) {
        return;
      }

      this.flexibleEnabled = Boolean(enabled);
      this.dataset.activeDealMode = this.flexibleEnabled ? "subscription" : "one-time";
      this.classList.toggle("product-tiers--flexible-subscription", this.flexibleEnabled);
      this.classList.toggle("product-tiers--flexible-one-time", !this.flexibleEnabled);
      this.flexibleToggle?.setAttribute("aria-checked", `${this.flexibleEnabled}`);

      if (!this.flexibleEnabled) {
        this.clearSellingPlan(false, false);
      }

      this.syncFlexibleFrequency(!this.isThemeEditor);
      this.updateFlexiblePlanData();
      this.updateFlexibleDiscountLabels();
      this.updateFlexiblePrices();
      this.updateFlexiblePlanTitle();
      this.updateFlexibleActiveDeal();

      if (syncKaching && !this.isThemeEditor) {
        this.selectKachingPanel(this.flexibleEnabled);
        window.setTimeout(() => {
          if (!this.flexibleEnabled) {
            this.clearSellingPlan(false, false);
          } else {
            this.syncFlexibleFrequency();
          }

          this.updateFlexiblePlanData();
          this.updateFlexibleDiscountLabels();
          this.updateFlexiblePrices();
          this.updateFlexiblePlanTitle();
          this.updateFlexibleActiveDeal();
        }, 0);
      }
    }

    updateFlexiblePrices() {
      if (!this.isFlexiblePlan) {
        return;
      }

      this.querySelectorAll("[data-flex-price]").forEach((element) => {
        const value = this.flexibleEnabled ? element.dataset.flexSubPrice : element.dataset.flexOneTimePrice;

        if (value) {
          element.textContent = value;
        }
      });

      this.querySelectorAll("[data-flex-compare]").forEach((element) => {
        const value = this.flexibleEnabled ? element.dataset.flexSubCompare : element.dataset.flexOneTimeCompare;
        const shouldHide = !value;

        element.textContent = value || "";
        element.classList.toggle("hidden", shouldHide);
      });

      this.querySelectorAll("[data-flex-unit]").forEach((element) => {
        const value = this.flexibleEnabled ? element.dataset.flexSubUnit : element.dataset.flexOneTimeUnit;

        if (value) {
          element.textContent = value;
          element.hidden = false;
          element.classList.remove("hidden");
        } else {
          element.textContent = "";
          element.hidden = true;
          element.classList.add("hidden");
        }
      });

      this.querySelectorAll("[data-flex-discount]").forEach((element) => {
        const value = this.flexibleEnabled ? element.dataset.flexSubDiscount : element.dataset.flexOneTimeDiscount;

        element.textContent = value || "";
        element.classList.toggle("hidden", !value);
      });
    }

    updateFlexibleActiveDeal() {
      if (!this.isFlexiblePlan) {
        return;
      }

      const selectedTier = this.querySelector(".product-tier input[type='radio']:checked")?.closest(".product-tier");
      const deal = this.getFlexibleTierDeal(selectedTier, this.flexibleEnabled);
      const price = deal.price;
      const buttonDiscount = this.formatFlexibleDiscountForButton(deal.discount);

      if (price) {
        this.dataset.activeDealPrice = price;
      } else {
        delete this.dataset.activeDealPrice;
      }

      if (buttonDiscount) {
        this.dataset.activeDealDiscount = buttonDiscount;
      } else {
        delete this.dataset.activeDealDiscount;
      }

      this.dataset.activeDealMode = this.flexibleEnabled ? "subscription" : "one-time";
      this.dispatchEvent(new CustomEvent("ark:flexible-plan-deal:change", {
        bubbles: true,
        detail: {
          price: price || "",
          discount: buttonDiscount,
          mode: this.dataset.activeDealMode
        }
      }));
    }

    getFlexibleTierDeal(tier, useSubscription = this.flexibleEnabled) {
      if (!tier) {
        return {
          price: "",
          discount: ""
        };
      }

      const priceElement = tier.querySelector("[data-flex-price]");
      const discountElement = tier.querySelector("[data-flex-discount]");
      const percent = this.getFlexibleTierDiscountPercent(tier, useSubscription);
      const discount = percent
        ? `SAVE ${percent}%`
        : useSubscription
          ? discountElement?.dataset.flexSubDiscount || ""
          : discountElement?.dataset.flexOneTimeDiscount || "";

      return {
        price: useSubscription ? priceElement?.dataset.flexSubPrice || "" : priceElement?.dataset.flexOneTimePrice || "",
        discount
      };
    }

    formatFlexibleDiscountForButton(value) {
      const match = `${value || ""}`.match(/(\d+(?:[.,]\d+)?)\s*%/);

      return match ? `${match[1].replace(",", ".")}% OFF` : "";
    }

    updateFlexiblePlanTitle() {
      if (!this.isFlexiblePlan || !this.flexiblePlanTitle) {
        return;
      }

      const selectedTier = this.querySelector(".product-tier input[type='radio']:checked")?.closest(".product-tier");
      const discountPercent = selectedTier ? this.getFlexibleTierDiscountPercent(selectedTier, true) : 0;
      const title = discountPercent
        ? `Save ${discountPercent}% With Flexible Plan`
        : selectedTier?.dataset.flexPlanTitle || this.flexiblePlanTitle.dataset.defaultTitle;

      if (title) {
        this.flexiblePlanTitle.textContent = title;
      }
    }

    updateFlexibleDiscountLabels() {
      if (!this.isFlexiblePlan) {
        return;
      }

      this.tiers.forEach((tier) => {
        const discountPercent = this.getFlexibleTierDiscountPercent(tier, true);
        const oneTimeDiscountPercent = this.getFlexibleTierDiscountPercent(tier, false);
        const discountElement = tier.querySelector("[data-flex-discount]");

        if (!discountElement) {
          return;
        }

        if (discountPercent) {
          const discount = `SAVE ${discountPercent}%`;

          tier.dataset.flexDiscountPercent = `${discountPercent}`;
          tier.dataset.flexPlanTitle = `Save ${discountPercent}% With Flexible Plan`;
          discountElement.dataset.flexSubDiscount = discount;
        } else {
          delete tier.dataset.flexDiscountPercent;
          discountElement.dataset.flexSubDiscount = "";
        }

        discountElement.dataset.flexOneTimeDiscount = oneTimeDiscountPercent
          ? `SAVE ${oneTimeDiscountPercent}%`
          : "";
      });
    }

    updateFlexiblePlanData(selectedOptions = this.getSelectedOptions()) {
      if (!this.isFlexiblePlan) {
        return;
      }

      this.tiers.forEach((tier) => {
        const variant = this.getVariantForTier(tier, selectedOptions);
        const priceElements = tier.querySelectorAll("[data-flex-price]");
        const compareElements = tier.querySelectorAll("[data-flex-compare]");
        const discountElement = tier.querySelector("[data-flex-discount]");

        if (!variant) {
          return;
        }

        const oneTimePrice = Number(variant.price);
        const oneTimeComparePrice = Number(variant.compare_at_price);
        const hasOneTimePrice = Number.isFinite(oneTimePrice) && oneTimePrice > 0;
        const hasOneTimeCompare = Number.isFinite(oneTimeComparePrice) && oneTimeComparePrice > oneTimePrice;
        const oneTimeDiscountPercent = hasOneTimePrice && hasOneTimeCompare
          ? Math.max(0, Math.round(((oneTimeComparePrice - oneTimePrice) / oneTimeComparePrice) * 100))
          : 0;

        if (hasOneTimePrice) {
          priceElements.forEach((element) => {
            element.dataset.flexOneTimePrice = this.formatFlexibleMoney(oneTimePrice);
            element.dataset.flexOneTimePriceCents = `${Math.round(oneTimePrice)}`;
          });

          compareElements.forEach((element) => {
            element.dataset.flexOneTimeCompare = hasOneTimeCompare ? this.formatFlexibleMoney(oneTimeComparePrice) : "";
            element.dataset.flexOneTimeCompareCents = hasOneTimeCompare ? `${Math.round(oneTimeComparePrice)}` : "";
          });

          if (discountElement) {
            discountElement.dataset.flexOneTimeDiscount = oneTimeDiscountPercent ? `SAVE ${oneTimeDiscountPercent}%` : "";
          }
        }

        const allocation = this.getFlexibleSellingPlanAllocation(variant);
        const subscriptionPrice = Number(allocation?.price || allocation?.per_delivery_price);
        const subscriptionBasePrice = [
          allocation?.compare_at_price,
          variant.compare_at_price,
          variant.price
        ].map((value) => Number(value))
          .filter((value) => Number.isFinite(value) && value > 0)
          .reduce((highest, value) => Math.max(highest, value), 0);
        const hasSubscriptionPrice = Number.isFinite(subscriptionPrice) && subscriptionPrice > 0;
        const subscriptionDiscountPercent = hasSubscriptionPrice && subscriptionBasePrice > subscriptionPrice
          ? Math.max(0, Math.round(((subscriptionBasePrice - subscriptionPrice) / subscriptionBasePrice) * 100))
          : 0;

        if (subscriptionDiscountPercent) {
          tier.dataset.flexDiscountPercent = `${subscriptionDiscountPercent}`;
          tier.dataset.flexPlanTitle = `Save ${subscriptionDiscountPercent}% With Flexible Plan`;
        } else {
          delete tier.dataset.flexDiscountPercent;
          delete tier.dataset.flexPlanTitle;
        }

        if (hasSubscriptionPrice) {
          tier.dataset.flexBasePrice = subscriptionBasePrice ? `${Math.round(subscriptionBasePrice)}` : "";
          tier.dataset.flexSubscriptionPrice = `${Math.round(subscriptionPrice)}`;
        } else {
          delete tier.dataset.flexBasePrice;
          delete tier.dataset.flexSubscriptionPrice;
        }

        priceElements.forEach((element) => {
          element.dataset.flexSubPrice = hasSubscriptionPrice
            ? this.formatFlexibleMoney(subscriptionPrice)
            : element.dataset.flexOneTimePrice || "";
          element.dataset.flexSubPriceCents = hasSubscriptionPrice
            ? `${Math.round(subscriptionPrice)}`
            : element.dataset.flexOneTimePriceCents || "";
        });

        compareElements.forEach((element) => {
          element.dataset.flexSubCompare = subscriptionDiscountPercent ? this.formatFlexibleMoney(subscriptionBasePrice) : "";
          element.dataset.flexSubCompareCents = subscriptionDiscountPercent ? `${Math.round(subscriptionBasePrice)}` : "";
        });

        if (discountElement) {
          discountElement.dataset.flexSubDiscount = subscriptionDiscountPercent ? `SAVE ${subscriptionDiscountPercent}%` : "";
        }
      });
    }

    getFlexibleSellingPlanAllocation(variant) {
      const allocations = variant?.selling_plan_allocations || [];

      if (!allocations.length) {
        return null;
      }

      const currentPlanId = this.getPreferredFlexibleSellingPlanId();
      const exactAllocation = allocations.find((allocation) => {
        return `${allocation.selling_plan_id}` === `${currentPlanId}`;
      });

      if (exactAllocation) {
        return exactAllocation;
      }

      return allocations[0];
    }

    getFlexibleAllocationDiscountPercent(variant, allocation) {
      if (!variant || !allocation) {
        return 0;
      }

      const basePrice = [
        allocation.compare_at_price,
        variant.compare_at_price,
        variant.price
      ].map((value) => Number(value))
        .filter((value) => Number.isFinite(value) && value > 0)
        .reduce((highest, value) => Math.max(highest, value), 0);
      const subscriptionPrice = Number(allocation.price || allocation.per_delivery_price);

      if (!Number.isFinite(basePrice) || !Number.isFinite(subscriptionPrice) || basePrice <= 0 || subscriptionPrice <= 0) {
        return 0;
      }

      return Math.max(0, Math.round(((basePrice - subscriptionPrice) / basePrice) * 100));
    }

    getFlexibleTierDiscountPercent(tier, useSubscription = true) {
      if (!tier) {
        return 0;
      }

      const basePrice = this.getFlexibleTierMoneyValue(tier, useSubscription ? "subscription-base" : "one-time-base");
      const finalPrice = this.getFlexibleTierMoneyValue(tier, useSubscription ? "subscription" : "one-time");

      if (Number.isFinite(basePrice) && Number.isFinite(finalPrice) && basePrice > 0 && finalPrice > 0 && finalPrice < basePrice) {
        return Math.max(0, Math.round(((basePrice - finalPrice) / basePrice) * 100));
      }

      const discountElement = tier.querySelector("[data-flex-discount]");
      const label = useSubscription ? discountElement?.dataset.flexSubDiscount : discountElement?.dataset.flexOneTimeDiscount;
      const labelPercent = `${label || ""}`.match(/(\d+(?:[.,]\d+)?)\s*%/)?.[1]?.replace(",", ".");

      if (labelPercent) {
        const parsed = Number(labelPercent);

        if (Number.isFinite(parsed) && parsed > 0) {
          return Math.round(parsed);
        }
      }

      const fallback = useSubscription ? Number(tier.dataset.flexDiscountPercent) : 0;

      return Number.isFinite(fallback) && fallback > 0 ? Math.round(fallback) : 0;
    }

    getFlexibleTierMoneyValue(tier, type) {
      const priceElement = tier.querySelector("[data-flex-price]");
      const compareElement = tier.querySelector("[data-flex-compare]");
      const getPositiveNumber = (...values) => {
        return values
          .map((value) => Number(value))
          .find((value) => Number.isFinite(value) && value > 0) || 0;
      };

      let centsValue = 0;

      if (type === "subscription-base") {
        centsValue = [
          tier.dataset.flexBasePrice,
          compareElement?.dataset.flexSubCompareCents,
          compareElement?.dataset.flexOneTimeCompareCents,
          priceElement?.dataset.flexOneTimePriceCents
        ].map((value) => Number(value))
          .filter((value) => Number.isFinite(value) && value > 0)
          .reduce((highest, value) => Math.max(highest, value), 0);
      } else if (type === "subscription") {
        centsValue = getPositiveNumber(tier.dataset.flexSubscriptionPrice, priceElement?.dataset.flexSubPriceCents);
      } else if (type === "one-time-base") {
        centsValue = getPositiveNumber(compareElement?.dataset.flexOneTimeCompareCents, priceElement?.dataset.flexOneTimePriceCents);
      } else if (type === "one-time") {
        centsValue = getPositiveNumber(priceElement?.dataset.flexOneTimePriceCents);
      }

      if (Number.isFinite(centsValue) && centsValue > 0) {
        return centsValue;
      }

      const moneyText = type === "subscription-base"
        ? compareElement?.dataset.flexSubCompare || compareElement?.textContent
        : type === "one-time-base"
          ? compareElement?.dataset.flexOneTimeCompare || priceElement?.dataset.flexOneTimePrice || priceElement?.textContent
          : type === "one-time"
            ? priceElement?.dataset.flexOneTimePrice || priceElement?.textContent
            : priceElement?.dataset.flexSubPrice || priceElement?.textContent;

      return this.parseFlexibleMoneyValue(moneyText);
    }

    parseFlexibleMoneyValue(value) {
      const raw = `${value || ""}`.replace(/\s+/g, "").replace(/[^\d,.-]/g, "");

      if (!raw) {
        return 0;
      }

      const lastComma = raw.lastIndexOf(",");
      const lastDot = raw.lastIndexOf(".");
      const decimalSeparator = lastComma > lastDot ? "," : ".";
      let normalized = raw;

      if (lastComma !== -1 && lastDot !== -1) {
        const thousandsSeparator = decimalSeparator === "," ? "." : ",";
        normalized = raw.replace(new RegExp(`\\${thousandsSeparator}`, "g"), "").replace(decimalSeparator, ".");
      } else if (lastComma !== -1 || lastDot !== -1) {
        const separatorIndex = Math.max(lastComma, lastDot);
        const decimals = raw.length - separatorIndex - 1;

        if (decimals > 0 && decimals <= 2) {
          normalized = raw.replace(decimalSeparator, ".");
        } else {
          normalized = raw.replace(/[,.]/g, "");
        }
      }

      const parsed = Number(normalized);

      return Number.isFinite(parsed) ? parsed : 0;
    }

    getCurrentSellingPlanId() {
      if (!this.flexibleEnabled) {
        return "";
      }

      const input = this.getSellingPlanInputs().find((element) => !element.disabled && element.value);

      return input?.value || this.dataset.selectedSellingPlanId || "";
    }

    getPreferredFlexibleSellingPlanId() {
      const activeInput = this.getSellingPlanInputs().find((element) => !element.disabled && element.value);
      const frequencyButton = this.flexibleFrequencyOptions?.querySelector("[data-selling-plan-id][aria-current='true']");

      return activeInput?.value || this.dataset.selectedSellingPlanId || frequencyButton?.dataset.sellingPlanId || "";
    }

    getProductForms(preferredForm = null) {
      const forms = new Set();

      if (this.form) {
        forms.add(this.form);
      }

      if (this.formId && document.forms[this.formId]) {
        forms.add(document.forms[this.formId]);
      }

      if (this.formId) {
        const formById = document.getElementById(this.formId);

        if (formById?.matches?.('form[action*="/cart/add"], form[data-type="add-to-cart-form"]')) {
          forms.add(formById);
        }
      }

      if (preferredForm) {
        forms.add(preferredForm);
      }

      this.productTarget.querySelectorAll('form[action*="/cart/add"], form[data-type="add-to-cart-form"]').forEach((form) => {
        forms.add(form);
      });

      return [...forms].filter(Boolean);
    }

	    normalizeSellingPlanKey(value) {
	      return String(value || "").toLowerCase().replace(/[\s_\-\[\]]/g, "");
	    }

	    isSellingPlanInput(input) {
	      if (!input) {
	        return false;
	      }

	      const name = input.getAttribute?.("name") || input.dataset?.arkFlexibleName || "";
	      const normalizedName = this.normalizeSellingPlanKey(name);

	      return Boolean(input.dataset?.arkFlexibleName) || normalizedName.includes("sellingplan");
	    }

	    getFormSellingPlanInputs(form) {
	      if (!form) {
	        return [];
	      }

	      const inputs = new Set();
	      const formId = form.getAttribute("id") || form.id;

	      Array.from(form.elements || []).forEach((input) => {
	        if (this.isSellingPlanInput(input)) {
	          inputs.add(input);
	        }
	      });

	      form.querySelectorAll("input, select, textarea").forEach((input) => {
	        if (this.isSellingPlanInput(input)) {
	          inputs.add(input);
	        }
	      });

	      if (formId) {
	        const escapedFormId = window.CSS?.escape ? window.CSS.escape(formId) : formId.replace(/"/g, '\\"');

	        document.querySelectorAll(`input[form="${escapedFormId}"], select[form="${escapedFormId}"], textarea[form="${escapedFormId}"]`).forEach((input) => {
	          if (this.isSellingPlanInput(input)) {
	            inputs.add(input);
	          }
	        });
	      }

	      return [...inputs];
	    }

    getSellingPlanInputs() {
      const inputs = new Set();

      this.getProductForms().forEach((form) => {
        this.getFormSellingPlanInputs(form).forEach((input) => inputs.add(input));
      });

      return [...inputs];
    }

	    deleteSellingPlanFromFormData(formData) {
	      if (!formData) {
	        return;
	      }

	      formData.delete("selling_plan");
	      formData.delete("sellingPlan");

	      Array.from(formData.keys()).forEach((key) => {
	        const normalizedKey = this.normalizeSellingPlanKey(key);

	        if (normalizedKey.includes("sellingplan")) {
	          formData.delete(key);
	        }
	      });
	    }

    storeSellingPlanInputName(input) {
      if (!input) {
        return;
      }

      const currentName = input.getAttribute("name");

      if (currentName && !input.dataset.arkFlexibleName) {
        input.dataset.arkFlexibleName = currentName;
      } else if (!input.dataset.arkFlexibleName) {
        input.dataset.arkFlexibleName = "selling_plan";
      }
    }

    disableSellingPlanInput(input) {
      if (!input) {
        return;
      }

      this.storeSellingPlanInputName(input);
      input.value = "";
      input.setAttribute("value", "");
      input.disabled = true;
      input.dataset.arkFlexibleDisabled = "true";
      input.removeAttribute("name");
    }

    enableSellingPlanInput(input, planId) {
      if (!input) {
        return;
      }

      const name = input.dataset.arkFlexibleName || "selling_plan";

      input.setAttribute("name", name);
      input.disabled = false;
      delete input.dataset.arkFlexibleDisabled;
      input.value = planId;
      input.setAttribute("value", planId);
    }

    clearCartFormSellingPlanPayload(formData = null, form = null) {
      this.clearSellingPlan(false, false);
      this.getFormSellingPlanInputs(form).forEach((input) => {
        this.disableSellingPlanInput(input);
      });
      this.deleteSellingPlanFromFormData(formData);
    }

    getSelectedTierVariantId() {
      return this.querySelector(".product-tier input[type='radio']:checked")?.dataset.variantId || "";
    }

    applySelectedVariantToCartPayload(formData = null, form = null) {
      const variantId = this.getSelectedTierVariantId();

      if (!variantId) {
        return;
      }

      const variantInput = form?.querySelector('[name="id"]') || this.form?.querySelector('[name="id"]');

      if (variantInput) {
        variantInput.disabled = false;
        variantInput.value = variantId;
        variantInput.setAttribute("value", variantId);
      }

      formData?.set("id", variantId);
    }

    ensureSellingPlanInputs(preferredForm = null) {
      return this.getProductForms(preferredForm).map((form) => {
        let input = this.getFormSellingPlanInputs(form).find((element) => element.tagName === "INPUT");

        if (!input) {
          input = document.createElement("input");
          input.type = "hidden";
          input.name = "selling_plan";
          input.dataset.arkFlexibleName = "selling_plan";
          form.appendChild(input);
        }

        this.storeSellingPlanInputName(input);
        return input;
      });
    }

    clearSellingPlan(shouldDispatch = true, forgetPlan = true) {
      if (forgetPlan) {
        delete this.dataset.selectedSellingPlanId;
      }

      this.getSellingPlanInputs().forEach((input) => {
        const hadValue = input.value;

        this.disableSellingPlanInput(input);

        if (shouldDispatch && hadValue) {
          input.dispatchEvent(new Event("change", { bubbles: true }));
        }
      });
    }

    activateSellingPlanInput(planId, shouldDispatch = true, preferredForm = null) {
      if (!planId) {
        this.clearSellingPlan(shouldDispatch);
        return;
      }

      this.dataset.selectedSellingPlanId = `${planId}`;
      this.ensureSellingPlanInputs(preferredForm).forEach((input) => {
        const previousValue = input.value;

        this.enableSellingPlanInput(input, planId);

        if (shouldDispatch && previousValue !== `${planId}`) {
          input.dispatchEvent(new Event("change", { bubbles: true }));
        }
      });
    }

    getCurrentFlexibleVariant(selectedOptions = this.getSelectedOptions()) {
      const selectedTier = this.querySelector(".product-tier input[type='radio']:checked")?.closest(".product-tier");

      return this.getVariantForTier(selectedTier, selectedOptions) || this.currentVariant || this.getVariantFromForm();
    }

    getSellingPlanName(planId) {
      const groups = window._ReStockConfig?.product?.selling_plan_groups || [];

      for (const group of groups) {
        const plan = group.selling_plans?.find((sellingPlan) => `${sellingPlan.id}` === `${planId}`);

        if (plan?.name) {
          return plan.name;
        }
      }

      const config = theme.helpers.safelyParseJson(this.getKachingRoot()?.getAttribute("config") || "{}") || {};
      const planConfig = config.sellingPlanConfigs?.[`gid://shopify/SellingPlan/${planId}`];
      const delivery = planConfig?.delivery;

      if (delivery?.frequency && delivery?.interval) {
        return `Every ${delivery.frequency} ${delivery.interval.toLowerCase()}`;
      }

      return "";
    }

    getFlexibleFrequencyPlans(selectedOptions = this.getSelectedOptions()) {
      const variant = this.getCurrentFlexibleVariant(selectedOptions);
      const seen = new Set();
      const seenNames = new Set();
      const plans = [];
    
      const addPlan = (rawId, rawName = "") => {
        const id = `${rawId || ""}`.match(/\d+/)?.[0] || "";
    
        if (!id || seen.has(id)) {
          return;
        }
    
        const name = `${rawName || this.getSellingPlanName(id) || ""}`.trim().replace(/^Delivery\s+/i, "");
        const nameKey = name.toLowerCase();
    
        // Only one entry per distinct frequency label. Several selling plans can
        // share a name (e.g. "Every 8 weeks" exists for every pack); without this
        // the dropdown listed the same frequency many times.
        if (name && seenNames.has(nameKey)) {
          return;
        }
    
        seen.add(id);
        if (name) {
          seenNames.add(nameKey);
        }
    
        plans.push({ id, name: name || `Plan ${plans.length + 1}` });
      };
    
      // Use ONLY the selected variant's allocations: these are exactly the
      // frequencies Kaching offers for this pack. Enumerating the whole selling
      // plan group / kaching <select> pulled in other packs' plans -> duplicates.
      (variant?.selling_plan_allocations || []).forEach((allocation) => {
        addPlan(
          allocation.selling_plan_id,
          allocation.selling_plan?.name || allocation.name || ""
        );
      });
    
      return plans;
    }

    getSelectedFlexibleFrequencyPlan(plans) {
      const currentPlanId = this.getPreferredFlexibleSellingPlanId();

      return plans.find((plan) => plan.id === currentPlanId)
        || plans[0]
        || null;
    }

    syncKachingFrequencySelect(planId) {
      const kachingRoot = this.getKachingRoot();

      kachingRoot?.querySelectorAll(".ark-kaching-frequency-select").forEach((select) => {
        if ([...select.options].some((option) => `${option.value}` === `${planId}`)) {
          select.value = planId;
        }
      });
    }

    setSellingPlan(planId, shouldRefresh = true) {
      if (!planId) {
        this.clearSellingPlan();
        return;
      }

      const normalizedPlanId = `${planId}`;

      this.dataset.selectedSellingPlanId = normalizedPlanId;
      this.syncKachingFrequencySelect(normalizedPlanId);

      if (this.isFlexiblePlan && !this.flexibleEnabled) {
        this.clearSellingPlan(false, false);
      } else {
        this.activateSellingPlanInput(normalizedPlanId);
      }

      if (!shouldRefresh) {
        return;
      }

      this.updateFlexiblePlanData();
      this.updateFlexibleDiscountLabels();
      this.updateFlexiblePrices();
      this.updateFlexiblePlanTitle();
      this.updateFlexibleActiveDeal();
      this.syncFlexibleFrequency(false);
    }

    syncFlexibleFrequency(shouldSetDefaultPlan = true) {
      if (!this.isFlexiblePlan || !this.flexibleFrequency) {
        return;
      }

      const plans = this.getFlexibleFrequencyPlans();
      const hasPlans = plans.length > 0;

      this.flexibleFrequency.hidden = !hasPlans;

      if (!hasPlans) {
        this.closeFlexibleFrequencyMenu();
        this.flexibleFrequency.hidden = true;

        if (!this.flexibleEnabled) {
          this.clearSellingPlan(false, false);
        }

        this.updateFlexibleActiveDeal();
        return;
      }

      const selectedPlan = this.getSelectedFlexibleFrequencyPlan(plans);

      if (selectedPlan?.id) {
        this.dataset.selectedSellingPlanId = selectedPlan.id;
        this.syncKachingFrequencySelect(selectedPlan.id);
      }

      if (shouldSetDefaultPlan && this.flexibleEnabled && selectedPlan && this.getCurrentSellingPlanId() !== selectedPlan.id) {
        this.setSellingPlan(selectedPlan.id, false);
      } else if (!this.flexibleEnabled) {
        this.clearSellingPlan(false, false);
      }

      if (this.flexibleFrequencyLabel && selectedPlan?.name) {
        this.flexibleFrequencyLabel.textContent = selectedPlan.name;
      }

      if (!this.flexibleFrequencyOptions) {
        return;
      }

      const signature = plans.map((plan) => `${plan.id}:${plan.name}`).join("|");

      if (this.flexibleFrequencyOptions.dataset.planSignature !== signature) {
        this.flexibleFrequencyOptions.innerHTML = "";
        plans.forEach((plan) => {
          const button = document.createElement("button");
          button.type = "button";
          button.className = "product-tiers__flexible-frequency-option";
          button.dataset.sellingPlanId = plan.id;
          button.textContent = plan.name;
          button.addEventListener("click", () => {
            this.setSellingPlan(plan.id);
            this.closeFlexibleFrequencyMenu();
          });
          this.flexibleFrequencyOptions.appendChild(button);
        });
        this.flexibleFrequencyOptions.dataset.planSignature = signature;
      }

      this.flexibleFrequencyOptions.querySelectorAll("[data-selling-plan-id]").forEach((button) => {
        const isCurrent = button.dataset.sellingPlanId === selectedPlan?.id;
        button.setAttribute("aria-current", `${isCurrent}`);
      });
    }

	    getActiveFlexibleSellingPlanId(preferredForm = null) {
	      if (!this.isFlexiblePlan || !this.isFlexibleSubscriptionActive()) {
	        this.clearCartFormSellingPlanPayload(null, preferredForm);
	        return "";
	      }

      const plan = this.getSelectedFlexibleFrequencyPlan(this.getFlexibleFrequencyPlans());
      const fallbackPlanId = this.dataset.selectedSellingPlanId || this.getCurrentSellingPlanId();
      const planId = plan?.id || fallbackPlanId;

      if (!planId) {
        this.clearCartFormSellingPlanPayload(null, preferredForm);
        return "";
      }

      this.activateSellingPlanInput(planId, false, preferredForm);
      return planId;
    }

	    prepareCartFormData(formData = null, form = null) {
	      if (!this.isFlexiblePlan || !(formData instanceof FormData)) {
	        return;
	      }
	    
	      // Build the cart payload (formData) ONLY. Never mutate the form's DOM
	      // here: mutating it makes Shop Pay / portable-wallets re-read the form and
	      // re-fire "formdata", which previously caused an infinite loop / freeze.
	    
	      // Submit the variant chosen by the selected tier.
	      const variantId = this.getSelectedTierVariantId();
	      if (variantId) {
	        formData.set("id", variantId);
	      }
	    
	      // Start clean: drop any selling_plan the form may have contributed.
	      this.deleteSellingPlanFromFormData(formData);
	    
	      if (!this.isFlexibleSubscriptionActive()) {
	        // Toggle OFF -> one-time purchase: no selling plan on the payload.
	        this.flexibleEnabled = false;
	        if (this.dataset.activeDealMode !== "one-time") {
	          this.dataset.activeDealMode = "one-time";
	        }
	        return;
	      }
	    
	      // Toggle ON -> subscription: add the selling plan to the payload.
	      this.flexibleEnabled = true;
	      if (this.dataset.activeDealMode !== "subscription") {
	        this.dataset.activeDealMode = "subscription";
	      }
	    
	      const planId = this.getFlexiblePlanIdForPayload();
	      if (planId) {
	        formData.set("selling_plan", planId);
	      }
	    }
	    
	    getFlexiblePlanIdForPayload() {
	      const plan = this.getSelectedFlexibleFrequencyPlan(this.getFlexibleFrequencyPlans());
	      return plan?.id || this.dataset.selectedSellingPlanId || this.getCurrentSellingPlanId() || "";
	    }

	    isFlexibleSubscriptionActive() {
	      if (!this.isFlexiblePlan) {
	        return false;
	      }

	      const toggleState = this.flexibleToggle?.getAttribute("aria-checked")
	        || this.querySelector("[data-flexible-plan-toggle]")?.getAttribute("aria-checked");

	      if (toggleState === "true") {
	        return true;
	      }

	      if (toggleState === "false") {
	        return false;
	      }

	      if (this.dataset.activeDealMode === "subscription") {
	        return true;
	      }

	      if (this.dataset.activeDealMode === "one-time") {
	        return false;
	      }

	      return Boolean(this.flexibleEnabled);
	    }

    toggleFlexibleFrequencyMenu() {
      if (!this.flexibleFrequencyMenu || !this.flexibleFrequencyToggle) {
        return;
      }

      const isExpanded = this.flexibleFrequencyToggle.getAttribute("aria-expanded") === "true";

      if (isExpanded) {
        this.closeFlexibleFrequencyMenu();
      } else {
        this.closeFlexibleInfo();
        this.syncFlexibleFrequency(false);
        this.flexibleFrequencyMenu.hidden = false;
        this.flexibleFrequencyToggle.setAttribute("aria-expanded", "true");
      }
    }

    closeFlexibleFrequencyMenu() {
      if (!this.flexibleFrequencyMenu || !this.flexibleFrequencyToggle) {
        return;
      }

      this.flexibleFrequencyMenu.hidden = true;
      this.flexibleFrequencyToggle.setAttribute("aria-expanded", "false");
    }

    formatFlexibleMoney(cents) {
      if (!Number.isFinite(Number(cents))) {
        return "";
      }

      if (window.Shopify?.formatMoney && window.settings?.moneyFormat) {
        return Shopify.formatMoney(Math.round(Number(cents)), window.settings.moneyFormat);
      }

      return `${Math.round(Number(cents) / 100)}`;
    }

    getKachingSubscriptionDiscount() {
      const { subscriptionPanel } = this.getKachingPanels();
      const text = subscriptionPanel?.textContent || "";

      if (!text) {
        return "";
      }

      const percentages = [...text.matchAll(/(\d{1,2})\s*%/g)]
        .map((match) => Number(match[1]))
        .filter((value) => Number.isFinite(value) && value > 0);

      return percentages.length ? Math.max(...percentages) : "";
    }

    toggleFlexibleInfo() {
      if (!this.flexibleInfo || !this.flexibleInfoToggle) {
        return;
      }

      const isExpanded = this.flexibleInfoToggle.getAttribute("aria-expanded") === "true";

      this.flexibleInfo.hidden = isExpanded;
      this.flexibleInfoToggle.setAttribute("aria-expanded", `${!isExpanded}`);
    }

    closeFlexibleInfo() {
      if (!this.flexibleInfo || !this.flexibleInfoToggle) {
        return;
      }

      this.flexibleInfo.hidden = true;
      this.flexibleInfoToggle.setAttribute("aria-expanded", "false");
    }

    handleFlexibleOutsideClick(event) {
      if (this.flexibleInfo && !this.flexibleInfo.hidden) {
        if (
          this.flexibleInfo.contains(event.target) ||
          this.flexibleInfoToggle?.contains(event.target)
        ) {
          return;
        }

        this.closeFlexibleInfo();
      }

      if (this.flexibleFrequencyMenu && !this.flexibleFrequencyMenu.hidden) {
        if (
          this.flexibleFrequencyMenu.contains(event.target) ||
          this.flexibleFrequencyToggle?.contains(event.target)
        ) {
          return;
        }

        this.closeFlexibleFrequencyMenu();
      }
    }

    getKachingRoot() {
      return this.productTarget.querySelector("kaching-subscriptions-block");
    }

    getKachingPanels() {
      const root = this.getKachingRoot();
      const panels = root ? [...root.querySelectorAll(".ks-panel")] : [];

      if (!panels.length) {
        return {};
      }

      const oneTimePanel = panels.find((panel) => /one[\s-]*time|one time purchase/i.test(panel.textContent || ""));
      const subscriptionPanel = panels.find((panel) => {
        return panel !== oneTimePanel && /subscribe|subscription|save/i.test(panel.textContent || "");
      }) || panels.find((panel) => panel !== oneTimePanel);

      return {
        oneTimePanel,
        subscriptionPanel
      };
    }

    isKachingPanelSelected(panel) {
      if (!panel) {
        return false;
      }

      const input = panel.querySelector("input[type='radio'], input[type='checkbox']");

      return panel.classList.contains("selected") || panel.getAttribute("aria-checked") === "true" || Boolean(input?.checked);
    }

    selectKachingPanel(useSubscription) {
      if (this.isThemeEditor) {
        return;
      }

      const { oneTimePanel, subscriptionPanel } = this.getKachingPanels();
      const panel = useSubscription ? subscriptionPanel : oneTimePanel;

      if (!panel || this.isKachingPanelSelected(panel)) {
        return;
      }

      const control = panel.querySelector("input[type='radio'], input[type='checkbox'], button, .ks-radio") || panel;
      control.click();
    }

    syncFlexiblePlanFromKaching() {
      if (this.isFlexiblePlan) {
        if (this.flexibleEnabled) {
          this.syncFlexibleFrequency(false);
        } else {
          this.clearSellingPlan(false, false);
        }

        return;
      }

      const { oneTimePanel, subscriptionPanel } = this.getKachingPanels();

      if (this.isKachingPanelSelected(subscriptionPanel)) {
        this.setFlexiblePlanState(true, false);
      } else if (this.isKachingPanelSelected(oneTimePanel)) {
        this.setFlexiblePlanState(false, false);
      }
    }

    formatAutomaticCaptionValue(value, index) {
      let text = `${value || ""}`.replace(/\s*\([^)]*\)\s*/g, " ").trim();

      if (index === 1 && text && !/\bbars?\b/i.test(text)) {
        text = `${text} Bars`;
      }

      return text;
    }
  }

  customElements.define("product-tiers", ProductTiers);
}


class ProductTabs extends HTMLElement {
  constructor() {
    super();

    this.tabs = this.querySelectorAll(".product-tabs__tab");
    this.productBlocks = this.querySelectorAll(".product-tabs__blocks");

    this.init();
  }

  init() {
    this.tabs.forEach((tab) => {
      tab.addEventListener("click", (evt) => {
        evt.preventDefault();

        const blockId = tab.dataset.blockId;

        this.showContent(blockId);

        this.tabs.forEach((innerTab) => {
          innerTab.classList.remove("underline");
          innerTab.removeAttribute("disabled");
        });

        tab.classList.add("underline");
        tab.setAttribute("disabled", "disabled");
      });
    });
  }

  showContent(blockId) {
    this.productBlocks.forEach((productBlock) => {
      productBlock.classList.add("product-tabs__blocks--refreshing");

      setTimeout(() => {
        if (productBlock.dataset.blockId === blockId) {
          productBlock.classList.remove("product-tabs__blocks--hidden");
        } else {
          productBlock.classList.add("product-tabs__blocks--hidden");
        }

        productBlock.classList.add("animated-blocks--hide-instantly");
        productBlock.classList.remove("visible");
        productBlock.classList.remove("product-tabs__blocks--refreshing");
      }, 300);

      setTimeout(() => {
        if (productBlock.dataset.blockId === blockId) {
          productBlock.classList.remove("animated-blocks--hide-instantly");
          productBlock.classList.add("visible");
        }
      }, 500);
    });
  }
}


if (!window.customElements.get("product-tabs")) {
  class ProductTabs extends HTMLElement {
    constructor() {
      super();

      this.tabs = this.querySelectorAll(".product-tabs__tab");
      this.productBlocks = this.querySelectorAll(".product-tabs__blocks");

      this.init();
    }

    init() {
      this.tabs.forEach((tab) => {
        tab.addEventListener("click", (evt) => {
          evt.preventDefault();

          const blockId = tab.dataset.blockId;

          this.showContent(blockId);

          this.tabs.forEach((innerTab) => {
            innerTab.classList.remove("underline");
            innerTab.removeAttribute("disabled");
          });

          tab.classList.add("underline");
          tab.setAttribute("disabled", "disabled");
        });
      });
    }

    showContent(blockId) {
      this.productBlocks.forEach((productBlock) => {
        productBlock.classList.add("product-tabs__blocks--refreshing");

        setTimeout(() => {
          if (productBlock.dataset.blockId === blockId) {
            productBlock.classList.remove("product-tabs__blocks--hidden");
          } else {
            productBlock.classList.add("product-tabs__blocks--hidden");
          }

          productBlock.classList.add("animated-blocks--hide-instantly");
          productBlock.classList.remove("visible");
          productBlock.classList.remove("product-tabs__blocks--refreshing");
        }, 300);

        setTimeout(() => {
          if (productBlock.dataset.blockId === blockId) {
            productBlock.classList.remove("animated-blocks--hide-instantly");
            productBlock.classList.add("visible");
          }
        }, 500);
      });
    }
  }

  customElements.define("product-tabs", ProductTabs);
}


if (!window.customElements.get("geo-shipping-notice")) {
  class GeoShippingNotice extends HTMLElement {
    constructor() {
      super();

      this.settings = theme.helpers.safelyParseJson(this.getAttribute("settings"));
      this.message = this.querySelector(".geo-shipping-notice__message");
      this.cacheKey = "geoShippingCountry";

      this.init();
    }

    init() {
      if (!this.message || !this.settings) {
        return;
      }

      const excluded = this.settings.excludedCountries.split(",").map((c) => c.trim().toUpperCase());
      // const cached = this.getCached();

      // if (cached) {
      //   this.renderMessage(excluded, cached.country, cached.code);

      //   return;
      // }

      if (this.settings.country) {
        const country = this.settings.country;
        const code = this.settings.countryCode;

        // this.setCached(country, code);
        this.renderMessage(excluded, country, code);

        this.classList.remove("invisible");
      } else {
        this.message.innerText = "Unable to detect location.";

        this.classList.add("!hidden");
      }

      // fetch(`${window.Shopify.routes.root}browsing_context_suggestions.json?country[enabled]=true&country[exclude]=${window.Shopify.country}&language[enabled]=true&language[exclude]=${window.Shopify.language}`)
      //   .then((res) => res.json())
      //   .then((data) => {
          
      //   })
      //   .catch(() => {
          
      //   });
    }

    renderMessage(excluded, country, code) {
      const flag = code ? String.fromCodePoint(...[...code].map((c) => 127397 + c.charCodeAt())) : "🌐";
      const isExcluded = excluded.includes(code);
      const template = isExcluded ? this.settings.messageUnsupported : this.settings.messageSupported;

      this.message.innerHTML = template.replace("[country]", country).replace("[flag]", flag);

      this.classList.remove("invisible");
    };

    getCached() {
      const oneDay = 24 * 60 * 60 * 1000;

      try {
        const cached = JSON.parse(localStorage.getItem(this.cacheKey));

        if (cached && Date.now() - cached.timestamp < oneDay) {
          return cached;
        }
      } catch {}

      localStorage.removeItem(this.cacheKey);

      return null;
    };

    setCached(country, code) {
      localStorage.setItem(this.cacheKey, JSON.stringify({
        country,
        code,
        timestamp: Date.now()
      }));
    };
  }

  customElements.define("geo-shipping-notice", GeoShippingNotice);
}


if (!window.customElements.get("sticky-atc-bar")) {
  class StickyAtcBar extends HTMLElement {
    constructor() {
      super();

      this.isThemeEditor = arkProductIsThemeEditor();
      this.isReady = false;

      if (this.isThemeEditor) {
        return;
      }

      this.sectionId = this.dataset.sectionId;
      this.section = document.querySelector(`.product-section[data-section-id="${this.sectionId}"]`);
      this.position = this.dataset.position;
      this.select = this.querySelector(".sticky-atc-bar__select");
      this.image = this.querySelector(".sticky-atc-bar__image img");
      this.atcButton = this.section?.querySelector(".product-form__buy-button");
      this.mainForm = this.atcButton?.closest("form");
      this.mainVariants = this.section?.querySelectorAll("variant-radios-detail fieldset") || [];
      this.variantsData = this.querySelector(".product-variants-json");
      this.variantsJSON = this.variantsData ? theme.helpers.safelyParseJson(this.variantsData.textContent) || [] : []
      this.form = this.querySelector("form");
      this.quantityInputs = [this.querySelector("input[name='quantity']"), this.section?.querySelector("input[name='quantity']")].filter(Boolean);

      this.buttonRect = null;
      this.isReady = Boolean(this.section && this.atcButton && this.mainForm && this.select && this.form);

      if (!this.isReady) {
        return;
      }

      this.init();

      this.handleScrollListener = theme.helpers.throttle(this.handleScroll.bind(this));
      this.handleVariantChangeListener = this.handleVariantChange.bind(this);
      this.handleSelectChangeListener = this.handleSelectChange.bind(this);
    }

    init() {
      this.moveOutsideSection();
      this.setInitialPosition();
      this.observeAtcButton();
      this.handleScroll();
      this.syncQuantityInputs();
      this.setBarHeight();
    }

    connectedCallback() {
      if (!this.isReady) {
        return;
      }

      window.addEventListener("scroll", this.handleScrollListener, { passive: true });
      this.mainForm?.addEventListener("variant:change", this.handleVariantChangeListener);
      this.select.addEventListener("change", this.handleSelectChangeListener);
    }

    disconnectedCallback() {
      if (!this.isReady) {
        return;
      }

      window.removeEventListener("scroll", this.handleScrollListener);
      this.mainForm?.removeEventListener("variant:change", this.handleVariantChangeListener);
      this.select.removeEventListener("change", this.handleSelectChangeListener);
    }

    setBarHeight() {
      document.documentElement.style.setProperty("--sticky-bar-height", `${this.getBoundingClientRect().height}px`);

      const resizeObserver = new ResizeObserver((entries) => {
        for (let entry of entries) {
          if (entry.target === this) {
            document.documentElement.style.setProperty("--sticky-bar-height", `${entry.target.getBoundingClientRect().height}px`);
          }
        }
      });

      resizeObserver.observe(this);
    }

    handleVariantChange(event) {
      const variant = event.detail.variant;

      if (variant) {
        const element = this.querySelector('[name="id"]');

        element.value = variant.id;
        element.dispatchEvent(new Event("change", { bubbles: true }));

        this.select.value = variant.id;

        this.form.dispatchEvent(new CustomEvent("variant:change", {
          detail: {
            variant: variant
          }
        }));
      }
    }

    handleSelectChange() {
      const option = this.select.options[this.select.selectedIndex];
      const imageSrc = option.dataset.image;
      const variantId = +this.select.value;
      const variant = this.variantsJSON.find((variant) => {
        return variant.id === variantId;
      });

      const element = this.querySelector('[name="id"]');

      element.value = variantId;
      element.dispatchEvent(new Event("change", { bubbles: true }));

      this.mainVariants.forEach((fieldset, index) => {
        const option = variant[`option${index + 1}`];
        const select = fieldset.querySelector("select");
        const radio = fieldset.querySelector(`input[type="radio"][value="${CSS.escape(option)}"]`);

        if (select) {
          select.value = option;
          select.dispatchEvent(new Event("change", { bubbles: true }));
        } else if (radio) {
          radio.checked = true;
          radio.dispatchEvent(new Event("change", { bubbles: true }));
        }
      });

      if (this.image && imageSrc) {
        this.image.src = imageSrc;
        this.image.removeAttribute("srcset");
      }
    }

    syncQuantityInputs() {
      this.quantityInputs.forEach((input) => {
        input.addEventListener("change", () => {
          const value = +input.value;

          this.quantityInputs.forEach((otherInput) => {
            if (otherInput !== input) {
              otherInput.value = value;
            }
          });
        });
      });
    }

    moveOutsideSection() {
      const existingStickyBar = document.querySelector("body > .sticky-atc-bar");

      existingStickyBar?.remove();

      document.body.appendChild(this);
    }

    setInitialPosition() {
      if (!this.atcButton) {
        return;
      }

      this.buttonRect = this.atcButton.getBoundingClientRect();
      this.buttonTopOffset = this.atcButton.getBoundingClientRect().top + window.scrollY;
    }

    handleScroll() {
      const scrollY = window.scrollY;

      if (!this.buttonRect) {
        return;
      }

      const isAbove = scrollY > this.buttonTopOffset + this.atcButton.offsetHeight;

      if (isAbove) {
        this.showSticky();
      } else {
        this.hideSticky();
      }
    }

    observeAtcButton() {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            this.setInitialPosition();

            if (entry.isIntersecting) {
              this.hideSticky();
            }
          });
        },
        {
          root: null,
          threshold: 0,
        }
      );

      observer.observe(this.atcButton);
    }

    showSticky() {
      this.classList.add("visible");
      document.body.classList.add("sticky-atc-bar-visible");
      document.body.classList.add(`sticky-atc-bar-position-${this.position}`);
    }

    hideSticky() {
      this.classList.remove("visible");
      document.body.classList.remove("sticky-atc-bar-visible");
    }
  }

  customElements.define("sticky-atc-bar", StickyAtcBar);
}
